import createReactComponent from '../createReactComponent';
var Edit2 = createReactComponent('Edit2', [['path', {
  d: 'M17 3a2.828 2.828 0 114 4L7.5 20.5 2 22l1.5-5.5L17 3z',
  key: 'kqzkv2'
}]]);
export default Edit2;